import { render, staticRenderFns } from "./LifeLicense.vue?vue&type=template&id=f8f0f27e&scoped=true"
import script from "./LifeLicense.vue?vue&type=script&lang=js"
export * from "./LifeLicense.vue?vue&type=script&lang=js"
import style0 from "./LifeLicense.vue?vue&type=style&index=0&id=f8f0f27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f0f27e",
  null
  
)

export default component.exports